module.exports = __webpack_public_path__ + "img/flood.bad5b79f.svg";